const actions = {
  SCHEDULER_UPDATE_BEGIN: 'SCHEDULER_UPDATE_BEGIN',
  SCHEDULER_UPDATE_SUCCESS: 'SCHEDULER_UPDATE_SUCCESS',
  SCHEDULER_UPDATE_ERR: 'SCHEDULER_UPDATE_ERR',

  TEMPLATE_LIST_BEGIN: 'TEMPLATE_LIST_BEGIN',
  TEMPLATE_LIST_SUCCESS: 'TEMPLATE_LIST_SUCCESS',
  TEMPLATE_LIST_ERR: 'TEMPLATE_LIST_ERR',

  ADDITIONAL_MESSAGE_LIST_BEGIN: 'ADDITIONAL_MESSAGE_LIST_BEGIN',
  ADDITIONAL_MESSAGE_LIST_SUCCESS: 'ADDITIONAL_MESSAGE_LIST_SUCCESS',
  ADDITIONAL_MESSAGE_LIST_ERR: 'ADDITIONAL_MESSAGE_LIST_ERR',

  HOST_LISTING_LIST_BEGIN: 'HOST_LISTING_LIST_BEGIN',
  HOST_LISTING_LIST_SUCCESS: 'HOST_LISTING_LIST_SUCCESS',
  HOST_LISTING_LIST_ERR: 'HOST_LISTING_LIST_ERR',

  CHANNEL_LIST_BEGIN: 'CHANNEL_LIST_BEGIN',
  CHANNEL_LIST_SUCCESS: 'CHANNEL_LIST_SUCCESS',
  CHANNEL_LIST_ERR: 'CHANNEL_LIST_ERR',

  CHANNEL_MESSAGE_UPDATE_BEGIN: 'CHANNEL_MESSAGE_UPDATE_BEGIN',
  CHANNEL_MESSAGE_UPDATE_SUCCESS: 'CHANNEL_MESSAGE_UPDATE_SUCCESS',
  CHANNEL_MESSAGE_UPDATE_ERR: 'CHANNEL_MESSAGE_UPDATE_ERR',

  schedulerUpdateBegin: () => {
    return {
      type: actions.SCHEDULER_UPDATE_BEGIN,
    };
  },

  schedulerUpdateSuccess: () => {
    return {
      type: actions.SCHEDULER_UPDATE_SUCCESS,
    };
  },

  schedulerUpdateErr: () => {
    return {
      type: actions.SCHEDULER_UPDATE_ERR,
    };
  },

  templateListBegin: () => {
    return {
      type: actions.TEMPLATE_LIST_BEGIN,
    };
  },

  templateListSuccess: () => {
    return {
      type: actions.TEMPLATE_LIST_SUCCESS,
    };
  },

  templateListErr: (data) => {
    return {
      type: actions.TEMPLATE_LIST_ERR,
      data,
    };
  },

  hostListingListBegin: () => {
    return {
      type: actions.HOST_LISTING_LIST_BEGIN,
    };
  },

  hostListingListSuccess: () => {
    return {
      type: actions.HOST_LISTING_LIST_SUCCESS,
    };
  },

  hostListingListErr: (data) => {
    return {
      type: actions.HOST_LISTING_LIST_ERR,
      data,
    };
  },

  additionalMessageListingListBegin: () => {
    return {
      type: actions.ADDITIONAL_MESSAGE_LIST_BEGIN,
    };
  },

  additionalMessageListingListSuccess: () => {
    return {
      type: actions.ADDITIONAL_MESSAGE_LIST_SUCCESS,
    };
  },

  additionalMessageListingListErr: (data) => {
    return {
      type: actions.ADDITIONAL_MESSAGE_LIST_ERR,
      data,
    };
  },
  
  channelListBegin: (data) => {
    return {
      type: actions.CHANNEL_LIST_BEGIN,
      data,
    };
  },
  
  channelListSuccess: (data) => {
    return {
      type: actions.CHANNEL_LIST_SUCCESS,
      data,
    };
  },
  
  channelListErr: (data) => {
    return {
      type: actions.CHANNEL_LIST_ERR,
      data,
    };
  },

  updateChannelMessageBegin: (data) => {
    return {
      type: actions.CHANNEL_MESSAGE_UPDATE_BEGIN,
      data,
    };
  },
  
  updateChannelMessageSuccess: (data) => {
    return {
      type: actions.CHANNEL_MESSAGE_UPDATE_SUCCESS,
      data,
    };
  },
  
  updateChannelMessageErr: (data) => {
    return {
      type: actions.CHANNEL_MESSAGE_UPDATE_ERR,
      data,
    };
  },

};
export default actions;
